// extracted by mini-css-extract-plugin
export default {"editor":"Editor_editor__z3YmQ","menu":"Editor_menu__0p4rR","error":"Editor_error__kSfgf"};